import { Pipe, PipeTransform, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import * as _ from 'lodash';
import { normalizeCaseAndAccents } from '../utils/functions';
import moment from 'moment';

@Pipe({ name: 'deepObjFilter', pure: false })
export class DeepObjectFilterPipe implements PipeTransform {

    constructor(private authService: AuthService) {

    }

    transform(items, obj, prop = null) {

        return _.filter(items, (i) => {
            return _.every(_.keysIn(obj), (k) => {
                if (_.keys(_.get(prop, k)).length === 0) {
                    _.set(prop, 'prop', _.get(prop, k));
                }
                if (_.isBoolean(_.get(obj, k))) {
                    let target = _.get(obj, k, "not-found");
                    return target !== "not-found" ? this.hasValueIn(i, target, k, _.get(prop, `${k}.prop`), _.get(prop, `${k}.gt`), _.get(prop, `${k}.lt`)) : true
                } else {
                    let target = _.get(obj, k);
                    return target ? this.hasValueIn(i, target, k, _.get(prop, `${k}.prop`), _.get(prop, `${k}.gt`), _.get(prop, `${k}.lt`)) : true
                }

            })
        })
    }

    hasValueIn(obj, value, key, prop, gt, lt) {      // incidencia 581 estado resuelta, Se ha cambiado el orden de ka 34-36 y 37
        if(_.includes(key,'#')){
            key = _.get(_.split(key,'#'),'[0]');
        }
        const target = obj !== null ? _.get(obj, key, "not-found") : null;
        //Don't find key in current level
        if (target === "not-found") {
            return _.some(_.keysIn(obj), (property) => {
                const target = obj[property];
                if (_.isObject(target)) {
                    return this.hasValueIn(target, value, key, prop, gt, lt);
                }
            });
        }
        else {
            //If we find the key
            // 1. check if target is array or obj
            if (_.isArray(target) && target.length > 0) {
                return _.find(target, (elem) => {
                    return this.compareTargetVSValue(elem, value, prop, gt, lt);
                });
            }
            else {
                return this.compareTargetVSValue(target, value, prop, gt, lt);
            }
            /* if (_.isArray(value) && value.length > 0) {
                 return _.find(value, (elem) => {
                     return _.isObject(target) ? _.isEqual(target, elem) : _.includes(normalizeCaseAndAccents(target), normalizeCaseAndAccents(elem));
                 });
             }
             else {
                 return _.isObject(target) ? _.isEqual(target, value) : _.includes(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
             }*/
        }
    }

    compareTargetVSValue(target, value, prop, gt, lt) {
        if (_.isArray(value) && value.length > 0) {
            return _.find(value, (elem) => {
                return this.findValue(target, elem, prop, gt, lt);
            });
        }
        else {
            return this.findValue(target, value, prop, gt, lt);
        }
    }

    findValue(target, value, prop, gt, lt) {
        if (_.isDate(value)) {
            value = moment(value).format('YYYY-MM-DD');
        }
        if (_.isObject(target)) {
            if (!prop) {
                prop = _.findKey(target, key => {
                    if (_.includes('id', key)) {
                        return key;
                    }
                });
            }
            if (_.isObject(value)) {
                if (gt) {
                    return _.gte(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                }
                else if (lt) {
                    return _.lte(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                }
                else {
                    return _.includes(_.toString(normalizeCaseAndAccents(_.get(target, prop))), _.toString(normalizeCaseAndAccents(_.get(value, prop))));
                }
            }
            else {
                if (gt) {
                    return _.gte(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                }
                else if (lt) {
                    return _.lte(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                }
                else {
                    return _.includes(normalizeCaseAndAccents(_.get(target, prop)), normalizeCaseAndAccents(value));
                }
            }
        }
        else {
            if (_.isObject(value)) {
                if (gt) {
                    return _.gte(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                }
                else if (lt) {
                    return _.lte(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                }
                else {
                    return _.includes(_.toString(normalizeCaseAndAccents(target)), _.toString(normalizeCaseAndAccents(_.get(value, prop))));
                }
            }
            else {
                if (_.isBoolean(value)) {
                    return target === value;
                } else {
                    if (gt) {
                        return _.gte(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                    }
                    else if (lt) {
                        return _.lte(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                    }
                    else {
                        return _.includes(normalizeCaseAndAccents(target), normalizeCaseAndAccents(value));
                    }
                }
            }

        }
    }

}